/** Motion tokens. One source of truth for landing page timing. */

export const duration = {
  fast: 0.15,
  base: 0.22,
  slow: 0.32,
} as const

export const ease = {
  standard: [0.32, 0.72, 0, 1] as [number, number, number, number],
}

export const enterVariants = {
  hidden: { opacity: 0, y: 8, filter: 'blur(4px)' },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { duration: duration.base, ease: ease.standard },
  },
}
